<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-3  w-100">
      <h4 class="title"><i class="fas fa-bell"></i> {{title | translate}}</h4>
    </div>
    <div class="col-md-2 mt-3 content-position-end">
      <button type="button"
              class="btn btn-outline-success custom-button mw-180 font-weight-bold"
              (click)="openAddModal()" *ngIf="hasAuthority('own:view:ads:add')">
        <i class="fa fa-plus"></i> {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="table-responsive mt-2 mb-2 custom-table-height">
  <table class="table-sm table-bordered">
    <thead>
    <tr>
      <th scope="col" title="#"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.DESCRIPTION' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.DATE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.IMAGE' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.SHOW-ADS' | translate }}"></th>
      <th scope="col" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let ads of listAds; let index=index">
      <td title="#"><b>{{(page.number * 10) + index + 1}}</b></td>
      <td title="{{ 'TABLE.HEADER.DESCRIPTION' | translate }}" class="w-550-px">
        <quill-editor class="ql-toolbar.ql-snow"
                      readOnly="true" theme="bubble"
                      [(ngModel)]="ads.description">
        </quill-editor>
      </td>
      <td title="{{ 'TABLE.HEADER.DATE' | translate }}">{{ads.createAt | dateformat}}</td>
      <td title="{{ 'TABLE.HEADER.IMAGE' | translate }}" (click)="viewImages(ads)">-
        <span *ngFor="let image of ads._more.adsImages">
          <img class="zoom" [src]="getUrlImage(image)"
               width="35" height="35" alt="Ads" *ngIf="isPresentImage(image)">
        </span>
      </td>
      <td title="{{ 'TABLE.HEADER.SHOW-ADS' | translate }}">
        <span
          class="{{!ads.showAds ? 'badge badge-danger':'badge badge-primary'}}">{{ads.showAds ? ('BUTTON.YES' | translate) : ('BUTTON.NO' | translate)}}</span>
      </td>
      <td title="{{ 'TABLE.HEADER.ACTION' | translate }}">
        <div class="dropdown">
          <button type="button" class="btn btn-default " id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <button class="dropdown-item pointer"
                    (click)="openModalEdit(ads)" *ngIf="hasAuthority('own:view:ads:edit')">
              <i class="fa fa-pen"> </i> {{ "BUTTON.EDIT" | translate }}
            </button>
            <button class="dropdown-item pointer"
                    (click)="viewImages(ads)" *ngIf="hasAuthority('own:view:ads:view')">
              <i class="fa fa-chevron-circle-right"> </i> {{ "BUTTON.VIEW-ADS-IMAGE" | translate }}
            </button>
            <button class="dropdown-item pointer"
                    (click)="openModalDelete(ads)" *ngIf="hasAuthority('own:view:ads:delete')">
              <i class="fa fa-trash"> </i> {{ "BUTTON.DELETE" | translate }}
            </button>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<nav class="Page navigation pagination-custom">
  <div class="row">
    <div class="col-md-8 mt-1">
      <div class="justify-content-row">
        <span class="mr-1 font-weight-normal">Mostrar </span>
        <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                (ngModelChange)="loadAds(enumPage.First)">
          <option *ngFor="let page of pageNumbers" [value]="page.value"
                  class="font-weight-bold">{{page.value}}</option>
        </select>
        <span class="font-weight-normal"> registros.</span>
      </div>
      <div class="page-total-entries">
        {{ "LABEL.TOTAL-RECORDS" | translate }}
        : {{listAds.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
      </div>
    </div>
    <div class="col-md-4">
      <ul class="pagination justify-content-end text-center">
        <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
          <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadAds(enumPage.First)"
             tabindex="-1" aria-disabled="true">
            <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
            {{ "BUTTON.FIRST" | translate }}
          </a>
        </li>
        <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
          <a class="left" (click)="loadAds(enumPage.Previous)">
            <i class="fa fa-angle-left" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
          <a class="right" (click)="loadAds(enumPage.Next)"><i
            class="fa fa-angle-right" aria-hidden="true"></i></a>
        </li>
        <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
            (click)="loadAds(enumPage.Last)">
          <a class="next">
            {{ "BUTTON.LAST" | translate }}
            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<app-loading *ngIf="loading"></app-loading>
